export default __webpack_public_path__ + "static/media/doodcat_nft.221ff753.png";